import {data}from "./data.js"

import Main from "../../components/Main/Main.js"


const Mercury = () => {
    return (
        <>
        <Main
        planetData={data}
        />
        </>
    )
}

export default Mercury